import { render, staticRenderFns } from "./ConstructionManagment.vue?vue&type=template&id=a2ca6db6&scoped=true&lang=pug&"
import script from "./ConstructionManagment.vue?vue&type=script&lang=ts&"
export * from "./ConstructionManagment.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionManagment.vue?vue&type=style&index=0&id=a2ca6db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca6db6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs,VTabsItems})
